import { apiGet } from '../shared/utils/apiClient'
import { API_CONFIG } from './config/api'

export interface FaqItem {
  id: string
  order: number
  title: {
    ru: string
    en: string
  }
  content: {
    ru: string
    en: string
  }
  defaultExpanded: boolean
  enabled: boolean
}

export interface FaqResponse {
  data: FaqItem[]
  meta: {
    total: number
    lang: string
    lastUpdated: string
  }
}

export const fetchFaqItems = async (): Promise<FaqItem[]> => {
  // Public endpoint - works without auth, but will include token if available
  const response = await apiGet(API_CONFIG.endpoints.faq.getAll)

  if (!response.ok) {
    throw new Error('Failed to fetch FAQ items')
  }

  const result: FaqResponse = await response.json()

  // Filter enabled items and sort by order (backend should already do this)
  return result.data
    .filter(item => item.enabled)
    .sort((a, b) => a.order - b.order)
}
